import { useEffect, useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { useParams } from "react-router-dom";
import { ScrollPanel } from 'primereact/scrollpanel';
import { Panel } from "primereact/panel";
import QuantityPricing from "../../models/QuantityPricing";
import { StyleQuantityPricingService } from "../../service/StyleQuantityPricingService";

const StyleQuantityPricing = () => {

    const [quantityPricing, setQuantityPricing] = useState<QuantityPricing[]>([]);
    const [loadingQuantityPricing, setLoadingQuantityPricing] = useState(true);
    const { styleCode } = useParams();

    useEffect(() => {
        if (!styleCode) { return; }

        StyleQuantityPricingService.getQuantityPricing(styleCode).then(quantityPricing => {
            setQuantityPricing(quantityPricing);
            setLoadingQuantityPricing(false);
        });

    }, [styleCode]);

    const beginQtyBodyTemplate = (rowData: QuantityPricing) => {
        return rowData.beginQty;
    }

    const endQtyBodyTemplate = (rowData: QuantityPricing) => {
        return rowData.endQty;
    }

    const priceBodyTemplate = (rowData: QuantityPricing) => {
        return rowData.price;
    }

    const costBodyTemplate = (rowData: QuantityPricing) => {
        return rowData.cost;
    }

    const packageBodyTemplate = (rowData: QuantityPricing) => {
        return rowData.package;
    }

    const lastUpdateBodyTemplate = (rowData: QuantityPricing) => {
        return rowData.updateDate;
    }

    const updateUserBodyTemplate = (rowData: QuantityPricing) => {
        return rowData.updateUser;
    }

    return (
        <div>
            <ScrollPanel style={{ width: '100%', height: 'calc(100vh - 20rem)' }}>
                <Panel header="Quantity Pricing">
                <DataTable value={quantityPricing} loading={loadingQuantityPricing}>
                    <Column field="BeginQty" body={beginQtyBodyTemplate} header="Begin Qty"></Column>
                    <Column field="EndQty" body={endQtyBodyTemplate} header="End Qty"></Column>
                    <Column field="Price" body={priceBodyTemplate} header="Price"></Column>
                    <Column field="Cost" body={costBodyTemplate} header="Cost"></Column>
                    <Column field="Package" body={packageBodyTemplate} header="Package"></Column>
                    <Column field="LastUpdate" body={lastUpdateBodyTemplate} header="Last Update"></Column>
                    <Column field="UpdateUser" body={updateUserBodyTemplate} header="Update User"></Column>
                </DataTable>
                </Panel>
            </ScrollPanel>
        </div>
    );

}

export default StyleQuantityPricing;